<template>
    <div class="form-group  ">
        <label>&nbsp;</label>

        <button type="button" class="btn btn-secondary btn-block" v-b-modal.selectModal @click="updateList()">
            {{label}}
        </button>
        <b-modal id="selectModal" hide-footer hide-header>
            <div style="margin: -16px">

                <div class="card">
                    <div class=" p-2 bg-light">
                        {{label}}
                    </div>

                    <b-list-group style="margin: -1px">

                        <b-list-group-item v-if="stackList.length" class="d-flex p-2" @click="backSelect">

                            <span style="margin: 4px 10px -4px 10px;">
                                 <i class="fa fa-angle-right" aria-hidden="true"></i>
                            </span>
                            <span class="ml-auto">بازگشت</span>


                        </b-list-group-item>


                        <b-form-radio-group v-model="selectedRadio" v-if="radio">
                            <b-list-group-item v-for="item in activeList" :key="item.id" class="d-flex p-2">

                                <b-form-radio :value="item.id"
                                              class="mr-1"
                                              name="item"
                                              @change="changeInput(item)"/>

                                <span class="ml-auto">{{item.title}}</span>

                                <span @click="nextSelect(item)" style="padding: 4px 10px 0px 4px;">
                                  <i class="fa fa-angle-left" v-show="item.child"
                                     aria-hidden="true"></i>

            </span>


                            </b-list-group-item>
                        </b-form-radio-group>


                        <template v-if="!radio">
                            <b-list-group-item v-for="item in activeList" :key="item.id" class="d-flex p-2">

                                <b-form-checkbox
                                        v-model="selected"
                                        :value="item.id"
                                        class="mr-1"
                                        name="item"
                                        @input="changeInput(item)"
                                        v-if="( !item.child)"/>


                                <span class="ml-auto">{{item.title}}</span>

                                <span @click="nextSelect(item)" style="padding: 4px 10px 0px 4px;">
                                  <i class="fa fa-angle-left" v-show="item.child"
                                     aria-hidden="true"></i>

            </span>


                            </b-list-group-item>

                        </template>

                    </b-list-group>

                </div>


            </div>

        </b-modal>
    </div>
</template>

<script>
    import mixinField from '../../mixins/mixinField';

    export default {
        mixins: [mixinField],

        name: "FieldSelectTree",
        props: ['radio', 'link'],
        data: function () {
            return {
                stackList: [],
                selectedRadio: 0,
                selected: [],
                name: "field_select_tree",
                rules: "",
                activeList: []
            }
        },
        mounted() {
            this.updateList()
        },
        watch: {

            value() {
                this.selected = this.value.split(',');
                this.selectedRadio = this.value;
            }


        },
        methods: {

            updateList() {
                this.axios.get(this.link).then(({data}) => {
                    this.activeList = data.data
                }).catch(function (error) {

                });
            },
            changeInput(item) {

                if (this.radio) {
                    this.$emit('input', item.id.toString())
                } else {
                    this.$emit('input', this.selected.join(','))
                }
            },
            nextSelect(item) {
                this.stackList.push(this.activeList);

                this.activeList = item.child

            },
            backSelect() {
                this.activeList = this.stackList.pop();
            }
        }
    }
</script>

<style scoped>

    .custom-control-inline {
        margin-left: 1rem;
        margin-right: 0rem;
    }

    .list-group-item:first-child {
        border-top-left-radius: 0rem;
        border-top-right-radius: 0rem;
    }

</style>


// WEBPACK FOOTER //
// src/components/fields/FieldSelectTree.vue